// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-dashboard-wrapper {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
}

.icon-dashboard-wrapper.center {
  justify-content: center;
}

.icon-dashboard-wrapper.right {
  justify-content: flex-end;
}

.icon-dashboard-wrapper.left {
  justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/icon-component/icon-component.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,2BAAA;AACF","sourcesContent":[".icon-dashboard-wrapper {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n}\n\n.icon-dashboard-wrapper.center {\n  justify-content: center;\n}\n\n.icon-dashboard-wrapper.right {\n  justify-content: flex-end;\n}\n\n.icon-dashboard-wrapper.left {\n  justify-content: flex-start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
